import React from "react";
import { Toast } from "react-bootstrap";
import { setComponentFlag, componentFlagValue } from "presentation/utils/functions/generic";

class ClassroomTimesheetTips extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        const { component, tipFlag } = this.props;

        return (
            <div className="tips-container">
                <Toast
                    onClose={() => setComponentFlag(component, tipFlag, false)}
                    show={componentFlagValue(component, tipFlag)}
                    delay={6000}
                    autohide
                    position={"top-end"}
                >
                    <Toast.Header className="toast-header-red">
                        <strong className="me-auto">BasicoApp</strong>
                    </Toast.Header>
                    <Toast.Body>Para adicionar itens ao quadro de horários, arraste uma atividade para tabela!</Toast.Body>
                </Toast>
            </div>
        );
    };
}

export default ClassroomTimesheetTips;


